export default __webpack_public_path__ + "static/media/crocodile.7fb21365.png";